import { USER_PROFILE } from "../apiEndpoint";
import { educationAxios } from "../http/http";

export default function userProfile(email) {
  return educationAxios.get(USER_PROFILE, {
    params: {
      user_email: email,
    },
  });
}